import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChatErrorAction, ChatErrorKind } from 'utils/chat/chatConstants';

const useChatError = () => {
    const { t } = useTranslation();
    const [chatError, setChatError] = useState(null);

    const buildChatError = useCallback(
        (kind) => {
            if (kind === ChatErrorKind.DISCONNECTED) {
                return {
                    actionLabel: t('controls.refresh', 'Refresh'),
                    actionType: ChatErrorAction.REFRESH,
                    icon: 'resync',
                    kind,
                    message: t('errors.chat-disconnect', 'Chat has been disconnected, please refresh your page'),
                };
            }

            if (kind === ChatErrorKind.UNSUPPORTED_REQUEST) {
                return {
                    actionLabel: null,
                    actionType: null,
                    icon: null,
                    kind,
                    message: t(
                        'errors.unsupported-request',
                        "Sorry, we couldn't help with your request. Try asking another question about your feedback."
                    ),
                };
            }

            return {
                actionLabel: t('controls.regenerate', 'Regenerate'),
                actionType: ChatErrorAction.REGENERATE,
                icon: 'refresh',
                kind: ChatErrorKind.GENERATION,
                message: t('message.something-went-wrong-try-again', 'Something went wrong, please try again'),
            };
        },
        [t]
    );

    const clearChatError = useCallback(() => {
        setChatError(null);
    }, []);

    return {
        buildChatError,
        chatError,
        clearChatError,
        setChatError,
    };
};

export default useChatError;
